import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { resolveUrl } from './util';
import { getMimeType } from './mimes';
import { isDataUrl, makeDataUrl, resourceToDataURL } from './dataurl';
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;

function toRegex(url) {
  // eslint-disable-next-line no-useless-escape
  var escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
  return new RegExp("(url\\(['\"]?)(".concat(escaped, ")(['\"]?\\))"), 'g');
}

export function parseURLs(cssText) {
  var urls = [];
  cssText.replace(URL_REGEX, function (raw, quotation, url) {
    urls.push(url);
    return raw;
  });
  return urls.filter(function (url) {
    return !isDataUrl(url);
  });
}
export function embed(_x, _x2, _x3, _x4, _x5) {
  return _embed.apply(this, arguments);
}

function _embed() {
  _embed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    var resolvedURL, contentType, dataURL, content;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            resolvedURL = baseURL ? resolveUrl(resourceURL, baseURL) : resourceURL;
            contentType = getMimeType(resourceURL);

            if (!getContentFromUrl) {
              _context.next = 10;
              break;
            }

            _context.next = 6;
            return getContentFromUrl(resolvedURL);

          case 6:
            content = _context.sent;
            dataURL = makeDataUrl(content, contentType);
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return resourceToDataURL(resolvedURL, contentType, options);

          case 12:
            dataURL = _context.sent;

          case 13:
            return _context.abrupt("return", cssText.replace(toRegex(resourceURL), "$1".concat(dataURL, "$3")));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);

          case 18:
            return _context.abrupt("return", cssText);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));
  return _embed.apply(this, arguments);
}

function filterPreferredFontFormat(str, _ref) {
  var preferredFontFormat = _ref.preferredFontFormat;
  return !preferredFontFormat ? str : str.replace(FONT_SRC_REGEX, function (match) {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      var _ref2 = URL_WITH_FORMAT_REGEX.exec(match) || [],
          _ref3 = _slicedToArray(_ref2, 3),
          src = _ref3[0],
          format = _ref3[2];

      if (!format) {
        return '';
      }

      if (format === preferredFontFormat) {
        return "src: ".concat(src, ";");
      }
    }
  });
}

export function shouldEmbed(url) {
  return url.search(URL_REGEX) !== -1;
}
export function embedResources(_x6, _x7, _x8) {
  return _embedResources.apply(this, arguments);
}

function _embedResources() {
  _embedResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cssText, baseUrl, options) {
    var filteredCSSText, urls;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (shouldEmbed(cssText)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", cssText);

          case 2:
            filteredCSSText = filterPreferredFontFormat(cssText, options);
            urls = parseURLs(filteredCSSText);
            return _context2.abrupt("return", urls.reduce(function (deferred, url) {
              return deferred.then(function (css) {
                return embed(css, url, baseUrl, options);
              });
            }, Promise.resolve(filteredCSSText)));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _embedResources.apply(this, arguments);
}